import React from 'react';

const FilterDetailsContext = React.createContext({
  branchIdVal: 1,
  moduleId: 2,
  sessionYearId: 1,
});
export default FilterDetailsContext;
